import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { dripiconlist } from "src/helpers/iconList";
import { updateHowToUseSaga } from "src/store/web-howtouse/saga";
import { HowToUseDetailDto } from "src/store/web-howtouse/type";
import * as Yup from "yup";

const HowToUseEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: HowToUseDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("HowToUse.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Title: data.Title,
          Description: data.Description,
          Icon: data.Icon,
          ShowWeb: data.ShowWeb,
          Translates: data.Translates,
        }}
        validationSchema={Yup.object().shape({
          Description: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Title: Yup.string().required(t("Validation.Required").toString()),
          Icon: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Description: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        onSubmit={(values) => {
          dispatch(
            updateHowToUseSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        multilanguageinputs={[
          {
            field: "Title",
            label: t("HowToUse.Title").toString(),
            type: "textarea",
          },
          {
            field: "Description",
            label: t("HowToUse.Description").toString(),
            isEditor: true,
          },
        ]}
        inputs={[
          {
            field: "Icon",
            placement: "top",
            label: t("HowToUse.Icon").toString(),
            type: "select",
            lookup: {
              renderValue: (e) => <i className={e} />,
              labelKey: "Id",
              valueKey: "Id",
              options: dripiconlist.map((x, i) => {
                return {
                  Id: x,
                  Name: x,
                };
              }),
            },
          },
          {
            field: "ShowWeb",
            label: t("HowToUse.ShowWeb").toString(),
            type: "switch",
            col: 6,
          },
        ]}
      />
    </React.Fragment>
  );
};
export default HowToUseEditForm;
